var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pdp-quantity-and-size" }, [
      _c(
        "label",
        {
          staticClass: "description text-uppercase font-weight-bold",
          attrs: { for: "quantity" }
        },
        [_vm._v(_vm._s(_vm.$resourceString["pdp.aside.bottom.quantity"]))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.quantity,
            expression: "quantity"
          }
        ],
        staticClass: "mb-2 form-control",
        attrs: {
          name: "quantity",
          type: "number",
          min: "1",
          max: _vm.trustedUser.quantityInStock
        },
        domProps: { value: _vm.quantity },
        on: {
          change: function($event) {
            return _vm.onQuantityChange($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.quantity = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        class: "wf-add-to-cart-button " + _vm.cssClasses,
        attrs: { type: "button", disabled: _vm.OrderSampleEnabled },
        on: { click: _vm.addItemToCart }
      },
      [
        _vm._t("default", [
          _c("span", { class: "png-icon png-icon-" + _vm.iconName }),
          _vm._v(" "),
          _c("span", { staticClass: "ml-2" }, [
            _vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }